import React, {useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import WizButton from '../../../components/button/WizButton'
import useNavigation from '../../../hooks/useNavigation'
import EventTable from '../../../features/page/leaderboard/event/EventTable'

interface IProps {
    className?: string
}

const EventPage: React.FC<IProps> = ({className}) => {
    const [showActive, setShowActive] = useState(false)
    const [priorityUpdate, setPriorityUpdate] = useState(false)
    const {goEventCreate} = useNavigation()

    return (
        <PageLayout title={'Event'}>
            <div className="flex justify-between items-center sm:block">
                <div className={'flex items-center space-x-[10px] sm:space-x-0 sm:flex sm:items-start sm:gap-x-[10px]'}>
                    <WizButton type={'primary'} text={'Create Event'} onClick={() => goEventCreate()} />
                </div>

                <div
                    className={
                        'flex gap-[10px] w-full justify-end items-center sm:block sm:mt-[20px] sm:space-y-[5px]'
                    }>
                    <a href={`https://leagueoftraders.io/announce`}>
                        <WizButton type={'blue'} text={'Go Announce'} />
                    </a>
                    <div>
                        <WizButton
                            type={priorityUpdate ? 'primary' : 'border'}
                            text={priorityUpdate ? 'Priority Update' : 'Priority Change'}
                            onClick={() => setPriorityUpdate(!priorityUpdate)}
                        />
                    </div>
                </div>
            </div>

            <div className={'mt-[30px]'}>
                <EventTable active={showActive} priorityActive={priorityUpdate} />
            </div>
        </PageLayout>
    )
}

export default EventPage
